var variationsItem = [
  {
    label: "",
    key: "selected",
    thStyle: { width: "45px",
    'min-width': "45px" },
    show: true,
    disabled: true,
  },
  {
    label: "Hình ảnh",
    key: "images",
    thStyle: { width: "77px",
    'min-width': "77px" },
    show: true,
    disabled: false,
  },
  {
    label: "Tên phiên bản",
    key: "nameOption",
    thStyle: { width: "210px",
    'min-width': "210px" },
    show: true,
    disabled: true,
  },
  {
    label: "Tên hiển thị",
    key: "name",
    thStyle: { width: "210px",
    'min-width': "210px" },
    show: true,
    disabled: false,
  },
  {
    label: "Giá nhập",
    key: "importPrice",
    thStyle: { width: "160px",'min-width': "160px", 'text-align': 'center'},
    show: true,
    disabled: false,
  },
  {
    label: "Giá bán",
    key: "exportPrice",
    thStyle: { width: "160px",'min-width': "160px", 'text-align': 'center'},
    show: true,
    disabled: false,
  },
  {
    label: "SKU",
    key: "sku",
    thStyle: { width: "160px", 'min-width': "160px" },
    show: true,
    disabled: true,
  },
  {
    label: "Barcode/UPC",
    key: "upc",
    thStyle: { width: "160px", 'min-width': "160px"},
    show: true,
    disabled: false,
  },
  {
    label: "",
    key: "edit",
    thStyle: { width: "44px" ,
    'min-width': "44px"},
    show: true,
    disabled: false,
  }
]

var variationsOnlyItem = [
  {
    label: "",
    key: "selected",
    thStyle: { width: "45px",
    'min-width': "45px" },
    show: true,
    disabled: true,
  },
  {
    label: "Tên phiên bản",
    key: "nameOption",
    thStyle: { width: "210px",
    'min-width': "210px" },
    show: true,
    disabled: true,
  },
  {
    label: "Tên hiển thị",
    key: "name",
    thStyle: { width: "210px",
    'min-width': "210px" },
    show: true,
    disabled: false,
  },
  {
    label: "Giá nhập",
    key: "importPrice",
    thStyle: { width: "17.5%",'min-width': "150px", 'text-align': 'center'},
    show: true,
    disabled: false,
  },
  {
    label: "Giá bán",
    key: "exportPrice",
    thStyle: { width: "17.5%",'min-width': "150px", 'text-align': 'center'},
    show: true,
    disabled: false,
  },
  {
    label: "Barcode",
    key: "upc",
    thStyle: { width: "15%", 'min-width': "100px" },
    show: true,
    disabled: false,
  },
  {
    label: "SKU",
    key: "sku",
    thStyle: { width: "15%", 'min-width': "100px" },
    show: true,
    disabled: true,
  },
  {
    label: "",
    key: "edit",
    thStyle: { width: "5%",
    'min-width': "50px" },
    show: true,
    disabled: true,
  }
]
var inventoryItem = [
  {
    label: "",
    key: "selected",
    thStyle: { width: "45px",
    'min-width': "45px" },
    show: true,
    disabled: true,
  },
  {
    label: "Phiên bản",
    key: "name",
    thStyle: { width: "15%",
    'min-width': "160px" },
    show: true,
    disabled: true,
  },
  // {
  //   label: "Lô-HSD",
  //   key: "batchCode",
  //   thStyle: { width: "15%",
  //   'min-width': "120px" },
  //   show: true,
  //   disabled: true,
  // },
  // {
  //   label: "NSX",
  //   key: "manufactureDate",
  //   thStyle: { width: "15%",
  //   'min-width': "120px" },
  //   show: true,
  //   disabled: true,
  // },
  // {
  //   label: "HSD",
  //   key: "expirationDate",
  //   thStyle: { width: "15%",
  //   'min-width': "120px" },
  //   show: true,
  //   disabled: true,
  // },
  {
    label: "Tồn hiện tại",
    key: "quantity",
    thStyle: { width: "10%",
    'min-width': "101px" },
    show: true,
    disabled: true,
  },
  {
    label: "Lý do",
    key: "reason",
    thStyle: { width: "25%",
    'min-width': "160px" },
    show: true,
    disabled: false,
  },
  {
    label: "SL tăng/giảm",
    key: "adjusted",
    thStyle: { width: "15%",
    'min-width': "120px" },
    show: true,
    disabled: false,
  },
  {
    label: "Sau điều chỉnh",
    key: "afterAdjusted",
    thStyle: { width: "15%",
    'min-width': "140px" },
    show: true,
    disabled: false,
  },
  {
    label: "Đ.vị tính",
    key: "unit",
    thStyle: { width: "10%",
    'min-width': "94px" },
    show: true,
    disabled: false,
  },
  {
    label: "",
    key: "edit",
    thStyle: { width: "5%",
    'min-width': "24px" },
    show: true,
    disabled: false,
  }
]
var inventoryItemLoHsd = [
  {
    label: "",
    key: "selected",
    thStyle: { width: "5%!important"},
    show: true,
    disabled: true,
  },
  {
    label: "Phiên bản",
    key: "name",
    thStyle: { width: "25%"},
    show: true,
    disabled: true,
  },
  {
    label: "Tồn hiện tại",
    key: "quantity",
    thStyle: { width: "10%",
    'min-width': "101px" },
    show: true,
    disabled: true,
  },
  {
    label: "Sau điều chỉnh",
    key: "afterAdjusted",
    thStyle: { width: "15%",
    'min-width': "140px" },
    show: true,
    disabled: false,
  },
  {
    label: "Đ.vị tính",
    key: "unit",
    thStyle: { width: "10%",
    'min-width': "94px" },
    show: true,
    disabled: false,
  },
  {
    label: "",
    key: "edit",
    thStyle: { width: "5%",
    'min-width': "24px" },
    show: true,
    disabled: false,
  }
]
var fieldItem = [
  {
    key: "selected",
    label: "",
    thStyle: { width: "5%" },
  },
  {
    key: "img",
    label: "Hình ảnh",
    thStyle: { width: "10%" },
  },
  {
    key: "name",
    label: "Sản phẩm",
    thStyle: { width: "15%" },
  },
  {
    key: "categorysub_name",
    label: "Danh mục",
    thStyle: { width: "30%" },
  },
  {
    key: "variable",
    label: "Số phiên bản",
    thStyle: { width: "10%" },
  },
  {
    key: "createdAt",
    label: "Ngày tạo",
    thStyle: { width: "20%" },
  },
  {
    key: "id",
    label: "",
    thStyle: { width: "10%" },
  },
]

export { variationsOnlyItem, inventoryItem, variationsItem, fieldItem, inventoryItemLoHsd }